import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const section = Component => props => (
  <div className="element-wrapper">
    <h1 className="element-header text-medium">{props.title}</h1>
    <Component {...props} />
  </div>
);

section.propTypes = {
  title: PropTypes.string.isRequired,
};

export default section;
